<app-banner></app-banner>
<app-feature></app-feature>
<app-about></app-about>
<app-roadmap></app-roadmap>
<app-bullish-by-design></app-bullish-by-design>
<app-how-to-buy></app-how-to-buy>
<app-tokenomics></app-tokenomics>
<!-- <app-news></app-news> -->
<app-faq></app-faq>
